import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddCreditRequest, CreditApiService, GetBalanceRequest, GetBalanceResponse } from '@vendasta/billing';
import { CreditBalance, creditBalanceFromApi } from './credit';

@Injectable({ providedIn: 'root' })
export class CreditService {
  constructor(private creditApi: CreditApiService) {}

  getBalance(merchantId: string): Observable<CreditBalance> {
    return this.creditApi
      .getBalance(
        new GetBalanceRequest({
          merchantId,
        }),
      )
      .pipe(map((res: GetBalanceResponse) => creditBalanceFromApi(res.creditBalance)));
  }

  add(
    merchantId: string,
    currency: string,
    amount: number,
    idempotencyKey?: string,
    reason?: string,
    memo?: string,
  ): Observable<null> {
    return this.creditApi
      .add(
        new AddCreditRequest({
          merchantId,
          currency,
          amount,
          idempotencyKey,
          reason,
          memo,
        }),
      )
      .pipe(map(() => null));
  }
}
